import React, {createContext} from 'react';

import axios from 'axios';
import { customLogger } from '../components/igtm/CustomLogger';


export const IsamsContext = createContext();

class IsamsContextProvider extends React.Component {

    constructor(props) {
        super(props);
        const obj = {
            isLoading: true,
            isChecking:true,
            checkHash:false,
            accessData:{}
        };

        if ('hash' in props) {
            obj.checkHash = props.hash;
        }

        this.state = obj;
    }

    componentDidMount() {
        this.loadData(this);
    }

    loadData(){

        if(this.state.checkHash){
            const apiPath = `${process.env.REACT_APP_API_URL}/connect/isamscode`;

            axios.post(apiPath,{
                goToken:this.state.checkHash
            },{
                timeout: 30000,
            }).then(res => {

                this.setState({
                    isChecking:false,
                    accessData:res.data,
                })

            }).catch(() => {
                localStorage.setItem('isamsFail',true);
                this.setState({
                    isChecking:false,
                    accessData:false,
                })
            });
        }
        else{
            const apiPath = `${process.env.REACT_APP_API_URL}/isams/setup`;

            axios.get(apiPath,{
                timeout: 30000,
            }).then(res => {
                this.setState({
                    isLoading:false,
                    accessData:res.data
                })
            }).catch(err => {
                // console.log('caught the error');
                customLogger(err);
            });
        }



    }

    render() {
        return (
            <IsamsContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </IsamsContext.Provider>
        );
    }
}

export default IsamsContextProvider;